<script>
    import {fade, fly} from 'svelte/transition';
    import Alert, {ALERTS} from "../stores/alerts";
    import AppIcon from "./icons/AppIcon.svelte";


    const yesHandler = () => {
        if ($Alert.yes_callback) {
            $Alert.yes_callback();
        }
        Alert.hide();
    }

    const noHandler = () => {
        if ($Alert.no_callback) {
            $Alert.no_callback();
        }
        Alert.hide();
    }
</script>

{#if $Alert.type}
    <div class="alert-overlay" transition:fade="{{ duration: 100 }}">
        <div class="alert-panel" in:fly="{{ y: -20, duration: 200 }}">
            <div class="close-button" on:click="{ noHandler }">
                <AppIcon icon="x" size="20" strokeWidth="2"/>
            </div>
            <div class="alert-body">
                {#if $Alert.title}
                    <h5 class="alert-title mb-1" class:text-danger={ $Alert.type === ALERTS.WARNING }>
                        { $Alert.title }
                    </h5>
                {/if}
                {@html $Alert.prompt}
            </div>
            <div class="alert-footer"
                 class:text-end={ $Alert.type == ALERTS.CONFIRM || $Alert.type == ALERTS.CONFIRM_EXIT || $Alert.type == ALERTS.DELETE }
                 class:text-center={ $Alert.type == ALERTS.ALERT || $Alert.type == ALERTS.WARNING }>
                {#if $Alert.type === ALERTS.ALERT }
                    <button class="btn btn-default rounded px-4" on:click="{ yesHandler }">Close</button>
                {:else if $Alert.type === ALERTS.CONFIRM } <!-- confirm -->
                    <button class="btn btn-default rounded me-3 px-5" on:click="{ noHandler }">No</button>
                    <button class="btn btn-primary rounded px-5" on:click="{ yesHandler }">YES</button>
                {:else if $Alert.type === ALERTS.DELETE }
                    <button class="btn btn-link btn-margin" on:click="{ noHandler }">Cancel</button>
                    <button class="btn btn-danger" on:click="{ yesHandler }">DELETE</button>
                {:else if $Alert.type === ALERTS.WARNING }
                    <button class="btn btn-default rounded px-4" on:click="{ yesHandler }">Close</button>
                {:else if $Alert.type === ALERTS.CONFIRM_EXIT } <!-- confirm exit -->
                    <button class="btn btn-link btn-margin" on:click="{ yesHandler }">Yes</button>
                    <button class="btn btn-primary px-4" on:click="{ noHandler }">NO</button>
                {/if}
            </div>
        </div>
    </div>
{/if}

<style>
    .alert-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.1);
        z-index: 9000;
    }

    .alert-panel {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
        width: max-content;
        max-width: 80%;
        color: #64748b;
        background: #fff;
        border-radius: 10px;
        overflow: hidden;
        padding-top: 5px;
        box-shadow: 0 11px 15px -7px rgba(0, 0, 0, .2), 0 24px 38px 3px rgba(0, 0, 0, .14), 0 9px 46px 8px rgba(0, 0, 0, .12);
    }

    .alert-panel .alert-body {
        font-size: 1rem;
        border-top-left-radius: 2px;
        border-top-right-radius: 2px;
        padding: 2rem;
    }

    .alert-panel .alert-title {
        color: #1e293b;
    }

    .alert-panel .alert-footer {
        background: #f8fafc;
        padding: 18px 20px;
    }

    .alert-panel .close-button {
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
        top: 10px;
        right: 10px;
        font-size: 2rem;
        color: #606f86;
        border-radius: 50%;
    }

    .alert-panel .close-button:hover {
        background: #f5f5f5;
    }

    @media (max-width: 575px) {
        .alert-panel {
            max-width: 90%;
            width: 90%;
        }
    }

    @media (min-width: 992px) {
        .alert-panel {
            min-width: 450px;
        }
    }
</style>